<template>
  <div class="details-view">
    <div class="main-content copyMonthSetting">
      <div class="section form-column">
        <el-form style="flex-direction: row;">
          <el-form-item style="margin-bottom: 15px!important;">
            <el-button v-if="!isEdit" type="primary" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
            <el-button v-if="isEdit" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
            <el-button type="primary" @click="refreshHandler">{{ $t('CargoMsg.Cargo_Refresh') }}</el-button>
          </el-form-item>
        </el-form>
        <el-form style="flex-direction: row;" label-width="150px" label-position="center">
          <span style="font-size:14px; margin-left: 20px; font-weight: bold;">{{ $t('PillReport.MonthlyDataArchive') }}</span>
          <el-form-item :label="$t('PillReport.MonthlyFinance')" style="margin-top: 10px;">
            <el-select v-model="setting.monthlyFinance" no="monthlyFinance" style="width: 150px;" :disabled="true">
              <el-option v-for="(item,index) in monthlyFinanceList" :key="index" :label="$store.getters.language === 'zh' ? item.name : item.englishName" :value="item.code" />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('PillReport.MonthlyHr')">
            <el-select v-model="setting.monthlyHr" no="monthlyHr" style="width: 150px;" :disabled="!isEdit">
              <el-option v-for="(item,index) in monthlyHrList" :key="index" :label="item.name" :value="item.code" />
            </el-select>
          </el-form-item>
          <span style="font-size:14px; margin-left: 20px; font-weight: bold;">{{ $t('PillReport.MonthDataArchive') }}</span>
          <el-form-item :label="$t('PillReport.WeeklyDay')" style="margin-top: 10px;">
            <el-select v-model="setting.weeklyDay" no="weeklyDay" style="width: 150px;" :disabled="!isEdit">
              <el-option v-for="(item,index) in weeklyDayList" :key="index" :label="$store.getters.language === 'zh' ? item.name : item.englishName" :value="item.code" />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import { queryPillCopyMonthSetting, savePillCopyMonthSetting } from '@/api/clearing/pillReport'

export default {
  name: 'TabCopyMonthSetting',
  props: { },
  data() {
    return {
      loading: false,
      setting: {
        monthlyFinance: 'LASTDAY',
        monthlyHr: 1,
        weeklyDay: 1
      },
      isEdit: false,
      monthlyFinanceList: [{ code: 'LASTDAY', name: '最后一个自然日', englishName: 'Last natural day' }],
      monthlyHrList: [{ code: 1, name: '1' }],
      weeklyDayList: [
        { code: 1, name: '一', englishName: 'MON' },
        { code: 2, name: '二', englishName: 'TUE' },
        { code: 3, name: '三', englishName: 'WED' },
        { code: 4, name: '四', englishName: 'THU' },
        { code: 5, name: '五', englishName: 'FRI' },
        { code: 6, name: '六', englishName: 'SAT' },
        { code: 7, name: '七', englishName: 'SUN' }]
    }
  },
  created() {
    // “每月固定日期（HR）”，范围1-28号
    this.monthlyHrList = []
    for (let i = 1; i <= 28; i++) {
      this.monthlyHrList.push({ code: i, name: i.toString() })
    }
    this.refreshHandler()
  },
  methods: {
    refreshHandler() {
      this.isEdit = false
      this.loading = getLoading()
      queryPillCopyMonthSetting().then(res => {
        this.setting = res.data
      }).finally(() => {
        this.loading.close()
      })
    },
    editHandler() {
      this.isEdit = true
    },
    // 保存
    saveHandler() {
      this.isEdit = false
      this.loading = getLoading()
      savePillCopyMonthSetting(this.setting).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.setting = res.data
      }).finally(() => {
        this.loading.close()
      })
    }
  }
}
</script>

<style lang="scss">

</style>
